<template>
  <!-- name: '个人中心-二级页面容器' -->
  <div class="secondWrap">

    <GoBack :title="title" />
    <van-loading v-if="isShow">加载中...</van-loading>
    <div style="height: 100%;background:#fff" v-else>
      <RegisterDefault v-if="isDefault" @setIsDefault="setIsDefault" />
      <Registered v-else />
    </div>

  </div>
</template>

<script>
import GoBack from "@/components/GoBack";
import RegisterDefault from "./components/registerDefault";
import Registered from "./components/registered";
import { myClothes } from "@/api/other.js"
export default {
  components: { GoBack, Registered, RegisterDefault },
  data() {
    return {
      title: "个人中心",
      isDefault: true,
      isShow: true,
    };
  },
  created() {
    this.title = this.$route.query.title;
    this.getMyClothes()
  },
  methods: {
    setIsDefault() {
      this.isDefault = !this.isDefault;
    },
    async getMyClothes() {
      const { content } = await myClothes({ type: 1 })
      this.isDefault = content.length > 0 ? false : true
      this.isShow = false
    }
  },
};
</script>

<style lang="scss" scoped>
.secondWrap {
  height: calc(100% - 100px);
  width: 100%;
  text-align: center;
  overflow: hidden;
  padding-bottom: 37px;
}
</style>
